import React from 'react';
import ConfigContext from './ConfigContext';

export default function withConfig(Component) {
  return React.forwardRef((props, ref) => (
    <ConfigContext.Consumer>
      {config => <Component ref={ref} {...props} config={config} />}
    </ConfigContext.Consumer>
  ));
}



// WEBPACK FOOTER //
// ./src/context/withConfig.js